import { render, staticRenderFns } from "./HomeFrame.vue?vue&type=template&id=1b16e210"
import script from "./HomeFrame.vue?vue&type=script&lang=js"
export * from "./HomeFrame.vue?vue&type=script&lang=js"
import style0 from "./HomeFrame.vue?vue&type=style&index=0&id=1b16e210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports